import { ArgumentError } from '../utils/errors';
import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class ProductModel extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    // TODO: handle limit/offset rules
    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][Event][getAll] organizationId is mandatory`);
        }
        return `/ticket/organizations/${organizationId}/products`;
    }

    static duplicate_action({ organizationId, productId, name, visible }) {
        return fetcher.post(`/ticket/organizations/${organizationId}/products/${productId}/duplicate`, { data: { name, visible } });
    }
}
